import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "./help_hints";
import "./css/wepcg_bar.css"

class PricingErrorBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Invoice Dispute (Pricing Error)</strong></h1>
            <p>
                This claim type is used if the pricing on invoice is not correct. Please attach as much background and evidence of entitlement to other price as possible. For price protection type of disputes please select dispute type „Price protection dispute“. Contact our financial claims team in case there is any question or problem.
            </p>
            <Help_hints />
        </div>
    }
}

export default PricingErrorBar;